import { LOCATION_UPDATE } from 'Store/location/constants';
import { RESET_LOCATION_SUCCESS, SET_TRAVEL_LOCATION_SUCCESS } from 'Store/passport/constants';
import { USER_DATA_SET_SUCCESS } from 'Store/profile/constants';

export const BLOCKED_REC_ACTION = 'BLOCKED_REC_ACTION';
export const CANCEL_RECS_CHANNEL = 'CANCEL_RECS_CHANNEL';
export const CHAT_BUBBLE_CONFIRMED = 'CHAT_BUBBLE_CONFIRMED';
export const CLEAR_RECS = 'CLEAR_RECS';
export const FIREBOARDING_SWIPE_COUNT = 45;
export const LIKE_STATUS = 'like';
export const LOAD_REC_BY_ID = 'LOAD_REC_BY_ID';
export const LOAD_REC_BY_ID_ERROR = 'LOAD_REC_BY_ID_ERROR';
export const LOAD_REC_BY_ID_SUCCESS = 'LOAD_REC_BY_ID_SUCCESS';
export const LOAD_RECS = 'LOAD_RECS';
export const LOAD_RECS_CHANNEL = 'LOAD_RECS_CHANNEL';
export const LOAD_RECS_EMPTY = 'LOAD_RECS_EMPTY';
export const LOAD_RECS_ERROR = 'LOAD_RECS_ERROR';
export const LOAD_RECS_SUCCESS = 'LOAD_RECS_SUCCESS';
export const NOPE_STATUS = 'dislike';
export const REC_LIKE_WITHOUT_MATCH = 'REC_LIKE_WITHOUT_MATCH';
export const REC_MATCH = 'REC_MATCH';
export const REC_OUT_OF_LIKES = 'REC_OUT_OF_LIKES';
export const REC_OUT_OF_LIKES_SUCCESS = 'REC_OUT_OF_LIKES_SUCCESS';
export const REC_OUT_OF_SUPERLIKES = 'REC_OUT_OF_SUPERLIKES';
export const REC_OUT_OF_SUPERLIKES_SUCCESS = 'REC_OUT_OF_SUPERLIKES_SUCCESS';
export const RECS_CLOSE_MODAL = 'RECS_CLOSE_MODAL';
export const RECS_DISLIKE = 'RECS_DISLIKE';
export const RECS_LIKE = 'RECS_LIKE';
export const RECS_OPEN_MODAL = 'RECS_OPEN_MODAL';
export const RECS_REWIND = 'RECS_REWIND';
export const RECS_REWIND_SUCCESS = 'RECS_REWIND_SUCCESS';
export const RECS_SUPERLIKE = 'RECS_SUPERLIKE';
export const RECS_SUPERLIKE_SUCCESS = 'RECS_SUPERLIKE_SUCCESS';
export const SET_QUEUE = 'SET_QUEUE';
export const SET_ACTIVE_QUEUE = 'SET_ACTIVE_QUEUE';
export const SET_PREVIOUS_REC = 'SET_PREVIOUS_REC';
export const SET_SUPERLIKE_UPSELL_REC_ID = 'SET_SUPERLIKE_UPSELL_REC_ID';
export const SUPERLIKE_STATUS = 'superlike';
export const TOGGLE_SUPERLIKE_STAR_ANIMATION = 'TOGGLE_SUPERLIKE_STAR_ANIMATION';
export const UPDATE_SUPERLIKES_REMAINING = 'UPDATE_SUPERLIKES_REMAINING';

export const REC_USER_ACTION_LIKE = LIKE_STATUS;
export const REC_USER_ACTION_SUPER_LIKE = SUPERLIKE_STATUS;
export const REC_USER_ACTION_REWIND = 'rewind';
export const REC_USER_ACTION_BOOST = 'boost';
export const REC_USER_ACTION_SUPER_BOOST = 'superboost';

export const recsRateMethods = {
  button: 'BUTTON',
  profileButton: 'PROFILE_BUTTON',
  swipe: 'SWIPE',
  keyboard: 'KEYBOARD',
  profileKeyboard: 'PROFILE_KEYBOARD',
};

export const QUEUE_MAIN = 'main';

export const RECS_REFRESH_ACTION_TYPES = [
  USER_DATA_SET_SUCCESS,
  LOCATION_UPDATE,
  SET_TRAVEL_LOCATION_SUCCESS,
  RESET_LOCATION_SUCCESS,
];

export const RECS_INTERACTION_TYPES = [LIKE_STATUS, NOPE_STATUS, SUPERLIKE_STATUS, RECS_REWIND];
